/* React hooks */
import { useEffect, useState } from 'react';
/* Routing */
import { Outlet } from 'react-router-dom';
/* Custom hooks */
import useRefreshToken from '../../hooks/useRefreshToken';
/* Contexts */
import useAuth from '../../hooks/useAuth';


export default function PersistLogin() {
    const [ isLoading, setIsLoading ] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                const refreshToken = localStorage.getItem('refresh_token');
                await refresh(refreshToken);
            }
            catch(err) {
                console.error('Erreur lors du rafraîchissement du token:', err);
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('old_refresh_token');
                localStorage.removeItem('persist');
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        !auth?.token
            ? verifyRefreshToken() : setIsLoading(false);

        return () => isMounted = false;
    }, )

    useEffect(() => {
    },[isLoading])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <p>Chargement de la page...</p>
                    : <Outlet />
            }
        </>
    )
}
